import React from 'react';
import CalendarWrapper from './CalendarWrapper';
import Todo from '../components/Todo/Todo';
import PowerContainer from '../components/Power/PowerContainer';
import './Family.css';


function Family(props) {
    return (
        <div className="familygrid-container">
            <div className="familygrid-item familygrid-item1">
                <CalendarWrapper />
            </div>
            <div className="familygrid-item familygrid-item2">
                <PowerContainer />
            </div>
            <div className="familygrid-item familygrid-item3">
                <Todo familyMemberName="Sivert" />

            </div>
            <div className="familygrid-item familygrid-item4">
                <Todo familyMemberName="Jenny" />
            </div>
        </div>

    );
}

export default Family;